import { Route } from "react-router-dom";
import React, { useEffect } from "react";

import LobConstants from "../../../constants/LobConstants";
import CurrentcompositionContext from "../../../common/contexts/CurrentcompositionContext";
// import CreateLegOrJobHeader from "./create/CreateLegOrJobHeader";
import CreateScheduleHeader from "./create/createscheduleheader";
import ScheduleMaintenanceList from "./list/SearchForm";

// import {
//     default as ApiServices
// } from "../../../common";
export default function ScheduleMaintenance() {
  useEffect(() => {
    console.log("Current Composition Component Mounted");
  }, []);
  return (
    <CurrentcompositionContext.Provider>
      <div>
        <Route
          path={`/${LobConstants.LOB}/maintenance/schedulemaintenance/createschedulemaintenance`}
          component={CreateScheduleHeader}
        />
        <Route
          path={`/${LobConstants.LOB}/maintenance/schedulemaintenance/list`}
          component={ScheduleMaintenanceList}
        />
      </div>
    </CurrentcompositionContext.Provider>
  );
}
